import { showSpotsLeft } from 'utils/spot-left';
const AVAILABLE_SPACES_THRESHOLD = 5;
const ETUI_DISPLAYED_NUMBER_QUERY_PARAM = 'etui_displayed_number';
export const shouldShowPriceUrgencyCallout = (tieredAvailability, availability, isShowSpotsLeftVisible) => {
    if (!tieredAvailability || isShowSpotsLeftVisible) {
        return false;
    }
    if (availability &&
        availability.availableSpaces <= AVAILABLE_SPACES_THRESHOLD) {
        return false;
    }
    const { currentTierInventoryRemaining, nextTierPriceDifference = 0, } = tieredAvailability;
    if (nextTierPriceDifference <= 0 || !currentTierInventoryRemaining) {
        return false;
    }
    return currentTierInventoryRemaining <= AVAILABLE_SPACES_THRESHOLD;
};
export const setPriceUrgencyCalloutInQueryParam = ({ availability, tieredAvailability, facilityType, }) => {
    const { available, availableSpaces } = availability || {};
    const isShowSpotsLeftVisible = showSpotsLeft({
        available,
        availableSpaces,
        facilityType,
    });
    const shouldShowPriceUrgency = shouldShowPriceUrgencyCallout(tieredAvailability, availability, isShowSpotsLeftVisible);
    if (!shouldShowPriceUrgency) {
        return null;
    }
    const currentTierInventoryRemaining = tieredAvailability?.currentTierInventoryRemaining;
    const queryParamToAppend = currentTierInventoryRemaining
        ? {
            [ETUI_DISPLAYED_NUMBER_QUERY_PARAM]: currentTierInventoryRemaining,
        }
        : null;
    return queryParamToAppend;
};
